<script setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 142 96">
    <title>{{ $t('logisticpartners.dhl') }}</title>
    <g fill="none">
      <path fill="#FFCB01" d="M0 0h142v96H0z" />
      <g fill="#D80613">
        <path
          d="m26.387 37.644-4.398 6h23.966c1.212 0 1.197.459.605 1.27-.602.82-1.608 2.237-2.222 3.072-.31.422-.873 1.19.989 1.19h9.8l2.905-3.965c1.801-2.455.157-7.564-6.283-7.564l-25.362-.003Z"
        />
        <path
          d="m20.209 57.195 8.834-12.056h10.962c1.211 0 1.196.46.604 1.268l-2.236 3.06c-.312.422-.874 1.19.988 1.19h14.681c-1.218 1.682-5.183 6.538-12.292 6.538H20.209Zm50.585-6.541-4.79 6.54H53.369l4.79-6.54h12.635Zm19.355-1.481H59.247l8.45-11.53h12.63l-4.842 6.612h5.636l4.848-6.611h12.63l-8.45 11.529Zm-1.085 1.48-4.79 6.542h-12.63l4.79-6.541h12.63v-.001Zm-86.882 2.58h18.61l-1.015 1.388H2.182v-1.388Zm0-2.58h20.502l-1.018 1.388H2.182v-1.388Zm0 5.16h16.722l-1.013 1.382H2.182v-1.382Zm137.639-1.192h-18.544l1.018-1.387h17.526v1.387Zm0 2.574h-20.427l1.01-1.38h19.417v1.38Zm-15.637-6.541h15.637v1.39h-16.652l1.015-1.39Zm-8.092-13.01-8.45 11.529H94.256l8.456-11.53h13.379l.001.001Zm-22.918 13.01s-.922 1.269-1.372 1.876c-1.584 2.155-.185 4.662 4.992 4.662h20.285l4.79-6.538H93.174Z"
        />
      </g>
    </g>
  </svg>
</template>
